//@flow
//Action Type Registered
export const THEIA_INV_SUBMIT_SUCCESS='THEIA_INV_SUBMIT_SUCCESS'
export const THEIA_INV_SUBMIT_ERROR='THEIA_INV_SUBMIT_ERROR'
export const THEIA_INV_SUBMITTED_COMPLETED='THEIA_INV_SUBMITTED_COMPLETED'
export const THEIA_EDIT_VERIFY_FORM_DATA_SUCCESS='THEIA_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const THEIA_EDIT_VERIFY_FORM_DATA_ERROR='THEIA_EDIT_VERIFY_FORM_DATA_ERROR'
export const THEIA_UPDATE_FORM_ERROR='THEIA_UPDATE_FORM_ERROR'
export const REFRESH_THEIA_VENDORS_SUCCESS='REFRESH_THEIA_VENDORS_SUCCESS'
export const REFRESH_THEIA_VENDORS_ERROR='REFRESH_THEIA_VENDORS_ERROR'
export const REFRESH_THEIA_DEPOSIT_ACCOUNTS_SUCCESS='REFRESH_THEIA_DEPOSIT_ACCOUNTS_SUCCESS'
export const REFRESH_THEIA_DEPOSIT_ACCOUNTS_ERROR='REFRESH_THEIA_DEPOSIT_ACCOUNTS_ERROR'


// WEBPACK FOOTER //
// ./src/redux/theia/actionTypes.js